import { Button, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from '../template/store';
import { IDataTableColumn } from '../../common/types/dataTable';
import DataTable from '../../common/components/DataTable';
import {
  clearRejectRemark,
  toggleColumnSettingsDashboard,
  updateRejectRemark,
  updateSelectedRequests,
  updateToggle,
} from './CustomerCodeDashboardSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../template/store';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { updateRowColumns } from './CustomerCodeDashboardSlice';
import { Link, matchPath, useLocation, useNavigate } from 'react-router-dom';
import { AESEncrypt } from '../../../encrypt-util';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import User from './User';
// import { getAllUserDetailsByUser } from './action/UserDetails';
import { faArrowAltCircleLeft } from '@fortawesome/free-regular-svg-icons';
import { AESDecrypt } from '../../../encrypt-util';
import { getUserProfile } from '../../common/actions/userDetails';
import FilterView from '../../common/components/FilterView';
import { getColumnViews } from '../../common/actions/dataTable';
import { updateDashbaordRefresh, updateParams } from '../../common/components/DataTable/slices/DataTable';
import { updateCurrentPageCustomerCodeDashboard } from '../dashboard/slices/dashboardSlice';
import { getDashboardData } from '../dashboard/actions/dashboard';
import quieryString from 'query-string';
import {
  IConfigsDefinition,
} from '../../utils/columnConfig';
import { updateDashbaordName } from '../../common/slices/navbarTop';
import OdexSpinner from '../../common/components/OdexSpinner';
import { useGenerateColumnConfig } from '../../../hooks/useGenerateColumnConfig';
import DashboardContainer from '../../../components/common/DashboardContainer';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useDataCountry from '../../../hooks/useDataCountry';
import { faCheck, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import CustomerCodeRequest from './CustomerCodeRequest';
import { toast } from "react-toastify";
import { approveRejectCustomerCodeRequest } from './CustomerCodeAction';
import moment from 'moment';
const dashboarName = 'CUSTOMER_CODE_DASHBOARD';
const uniqueFilterKey = 'customerCodeDetails';
const defaultSort = 'customer_mapping_request_id desc';

const CustomerCodeDashboard = () => {
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const navigate = useNavigate();
  const { userID } = useParams();
  const { t, i18n } = useTranslation();
  const rbac = useSelector((state: RootState) => state.userProfile);
  const params = useParams();

  const [previousState, setPreviousState] = useState<{
    filterState: string | null;
    search: string | null;
    grids: any[] | null;
  }>({ filterState: null, search: null, grids: null });

  const [configs, setConfigs] = useState<IConfigsDefinition>({
    columns: [],
    staticHiddenCols: [],
    defaultHiddenCols: [],
  });
  const [columns, setColumns] = useState<IDataTableColumn[]>([]);

  const customerCodeList = useSelector((state: RootState) => state.customerCodeList);
  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );
  const showColumnSettings = useSelector(
    (state: RootState) => state.customerCodeList.showColumnSettings
  );
  const loading = useSelector(
    (state: RootState) => state.dashboard.dataLoading
  );
  const dataLoading = useSelector(
    (state: RootState) => state.customerCodeList.dataLoading
  );

  const selectedRequests = useSelector((state: RootState) => state.customerCodeList.selectedRequests)

  const rejectRemark = useSelector(
    (state: RootState) => state.customerCodeList.rejectRemark
  );

  const grids = useSelector((state: RootState) => state.dataTable.customerCodeGrids);
  const sortState = useSelector(
    (state: RootState) => state.dataTable.sortState
  );
  const data = useSelector(
    (state: RootState) => state.dashboard.customerCodeDashboardList
  );
  const refresh = useSelector(
    (state: RootState) => state.dataTable.refreshDashboard
  );


  const filterState = useSelector(
    (state: RootState) => state.dataTable.filterState
  );

  const currentPageUser = useSelector(
    (state: RootState) => state.dashboard.currentPageCustomerCode
  );

  const selectedTopSearchFilter = useSelector(
    (state: RootState) => state.navbarTop.selectedTopSearchFilter
  );
  const searchInputValue = useSelector(
    (state: RootState) => state.navbarTop.searchInputValue
  );
  const userTopSearchState = useSelector(
    (state: RootState) => state.navbarTop.userTopSearchState
  );

  const setCurrentPage = (page: number) => {
    dispatch(updateCurrentPageCustomerCodeDashboard(page));
  };

  const selectedConfigId = useSelector(
    (state: RootState) => state.dataTable.selectedConfigId
  );

  const onHideColumnSettings = () => {
    dispatch(toggleColumnSettingsDashboard(false));
  };

  // const getParams = () => {
  //   return {
  //     user_id: AESDecrypt(location?.pathname?.split?.('/')?.[3]) || '',
  //   };
  // };

  const getParams = () => {
    return {
      customer_id: AESDecrypt(params.custId)
    };
  };

  function useDebouncedEffect(effect: any, deps: any, delay: any) {
    const callback = useRef<any>();

    useEffect(() => {
      callback.current = effect;
    }, [effect]);

    useEffect(() => {
      if (refresh) loadCustomerCodeDashboard(false);
      dispatch(updateDashbaordRefresh(false))
    }, [refresh]);

    useEffect(() => {
      const handler = () => {
        if (callback.current) {
          callback.current();
        }
      };

      const timer = setTimeout(handler, delay);

      return () => clearTimeout(timer);
    }, [...deps, delay]);
  }

  const filterStateLocal = filterState?.[uniqueFilterKey];
  const sort = (quieryString.parse(location.search)?.sort as string)
    ?.split(',')
    ?.join(' ');

  const generateColumnConfig = useGenerateColumnConfig()

  useEffect(() => {
    const userDashboardDefinition = grids?.[0]?.columnConfigGrid || '';
    if (!userDashboardDefinition) return;

    try {
      const configs = generateColumnConfig(
        JSON.parse(JSON.parse(userDashboardDefinition)),
        getParams,
      );

      const columns = configs?.columns?.map((c) => c);
      setConfigs(configs);
      setColumns(columns);
    } catch (e) {
      console.error('Column Error: ', e);
    }
  }, [grids, location]);
  const linerId = useSelector((state: RootState) => state.navbarTop.linerId);
  const language = useSelector((state: RootState) => state.navbarTop.language);

  const dataCountry = useDataCountry();

  const onApprove = (e: any) => {

    const payload = {
      customerMappingRequestIds: selectedRequests?.map((e) => { return e?.customer_mapping_request_id }) ?? [],
      action: "Approve",
      remark: rejectRemark?.trim() ?? ""
    }

    dispatch(approveRejectCustomerCodeRequest(payload))
      .unwrap()
      .then((res) => {
        if (res.status == "ERROR") {
          dispatch(updateSelectedRequests([]))
          toast.error(res?.message ?? "")
          setTimeout(() => {
          }, 2000);
        } else if (res.status == "SUCCESS") {
          dispatch(updateSelectedRequests([]))
          toast.success(res?.message ?? "")
          setTimeout(() => {
          }, 2000);
          navigate('/customerCode')
        }
        dispatch(updateDashbaordRefresh(true))
      })
      .catch((err) => {
        toast.error("Failed to Approve. Please try again.");
        console.error(err);
      })

    dispatch(clearRejectRemark());

  }

  const onReject = (e: any) => {

    if (!rejectRemark.trim()) {
      toast.error('Remark is mandatory for rejection');
      return;
    }
    const payload = {
      customerMappingRequestIds: selectedRequests?.map((e) => { return e?.customer_mapping_request_id }) ?? [],
      action: "Reject",
      remark: rejectRemark?.trim() ?? ""
    }


    dispatch(approveRejectCustomerCodeRequest(payload))
      .unwrap()
      .then((res) => {
        if (res.status == "ERROR") {
          toast.error(res?.message ?? "")
          dispatch(updateSelectedRequests([]))
          setTimeout(() => {
            dispatch(updateDashbaordRefresh(true))
          }, 2000);

        } else if (res.status == "SUCCESS") {
          toast.success(res?.message ?? "")
          dispatch(updateSelectedRequests([]))
          setTimeout(() => {
            dispatch(updateDashbaordRefresh(true))
          }, 2000);

          navigate('/customerCode')
        }

      })
      .catch((err) => {
        toast.error("Failed to Reject. Please try again.");
        console.error(err);
      })

    dispatch(clearRejectRemark());
  }


  useEffect(() => {
    dispatch(updateDashbaordName(dashboarName));
  }, []);

  useEffect(() => {
    if (dataCountry && linerId) {
      dispatch(
        getColumnViews({ gridName: dashboarName, country: dataCountry, linerId: linerId, language: language || localStorage.getItem('selectedLanguage') || 'EN' })
      );
    }
    dispatch(updateParams({}));
  }, [dataCountry, linerId, language]);
  const selectedPort = useSelector((state: RootState) => state.userProfile.selectedPort);
  useEffect(() => {
    loadCustomerCodeDashboard(false);
  }, [currentPageUser, selectedPort]);

  useEffect(() => {
    loadCustomerCodeDashboard(true);
  }, [location.pathname, linerId, language]);


  useDebouncedEffect(() => {
    const currentStateValue = {
      filterState: JSON.stringify(filterStateLocal),
      search: location.search,
      grids: grids,
    };

    if (JSON.stringify(previousState) !== JSON.stringify(currentStateValue)) {
      loadCustomerCodeDashboard(true);
      setPreviousState(currentStateValue);
    }
  }, [filterStateLocal, location.search, grids, linerId, language], 700);

  const FilterViewChild = (() => {
    return (
      <>
        {(profileDetails.partnerType === 'liner' && !location.pathname.includes('/companyDetails') && rbac.rbacDetails.customerCodeApproveReject == "Y") ? (
          <>
            <div className="row align-items-center g-2">
              <div className="col-auto">
                <Button
                  variant="falcon-primary"
                  className="px-2 approve"
                  size="sm"
                  data-placement="left"
                  data-toggle="tooltip"
                  disabled={!(Array.isArray(selectedRequests) && selectedRequests.length > 0)}
                  onClick={
                    // handle approve
                    onApprove
                  }
                >
                  <FontAwesomeIcon icon={faCheck} className="me-2 approve" />
                  <span>Approve</span>
                </Button>

              </div>
              <div className="col-auto">
                <Button
                  variant="falcon-primary"
                  className="px-2 reject"
                  size="sm"
                  data-placement="left"
                  data-toggle="tooltip"
                  disabled={!(Array.isArray(selectedRequests) && selectedRequests.length > 0)}
                  onClick={
                    onReject}
                >
                  <FontAwesomeIcon icon={faTimes} className="me-2 reject" />
                  <span>Reject</span>
                </Button>
              </div>
              <div className="col">


                <input
                  className={`form-control fs--1`}
                  value={rejectRemark || ''}
                  maxLength={250}
                  disabled={!(Array.isArray(selectedRequests) && selectedRequests.length > 0)}
                  onBlur={(e) => {
                    const trimmed = e.target.value.trim();
                  }}
                  placeholder='Enter Remarks'
                  onChange={(e) => {

                    dispatch(updateRejectRemark(e.target.value));
                  }}
                />
              </div>

            </div>
          </>

        ) : (
          (!location.pathname.includes('/request') && profileDetails.partnerType === 'customer' && rbac.rbacDetails.submitCustomerCodeReq == "Y") && (
            <Button
              variant="falcon-primary"
              className="ms-0 ps-0"
              size="sm"
              data-placement="left"
              data-toggle="tooltip"
              onClick={() => {
                navigate(`${APP_PATH_PREFIX}/customerCode/request`);
              }}
            >
              <FontAwesomeIcon
                icon={faPlus}
                className="mx-1 me-2 mt-1 text-warning"
              />
              <span>Customer Code</span>
            </Button>
          )
        )}
      </>
    );
  })();


  const loadCustomerCodeDashboard = (filterUpdated: boolean) => {
    if (filterUpdated) setCurrentPage(1);

    if (filterStateLocal) {
      if (Object.keys(filterStateLocal)?.length > 0) {
        const filterApiState: any = {};
        const filterKeys = Object.keys(filterStateLocal);

        for (let k of filterKeys) {
          if (filterStateLocal?.[k]?.from) {
            filterApiState[k] = [
              filterStateLocal?.[k]?.from || '',
              filterStateLocal?.[k]?.to || '',
            ].filter((i) => i);
          } else if (filterStateLocal?.[k]?.from !== undefined) {
            filterApiState[k] = undefined;
          } else {
            filterApiState[k] = filterStateLocal?.[k]
              ? typeof filterStateLocal?.[k] === 'string'
                ? [filterStateLocal?.[k]]
                : filterStateLocal?.[k]
              : undefined;
          }
        }
        if (Object.keys(filterApiState)?.length > 0) {
          const finalFilterApiState: any =
            (selectedTopSearchFilter?.id && searchInputValue.trim() != '') ?
              { [selectedTopSearchFilter?.id]: [searchInputValue.trim()] } : {};
          const currentDate = new Date();
          if (grids[0]) {
            let timeFlag = '';
            let timeDiff = 0;
            let dateRange: any = {};

            const newdata = grids[0].configGroup?.find(
              (c: any) => c.userGridId == selectedConfigId?.[`${uniqueFilterKey}`]
            )?.columnConfigGrid;
            if (newdata) {
              timeFlag = JSON.parse(newdata).find(
                (item: any) => item.accessor == 'invdt'
              )?.filterState;
              timeDiff = JSON.parse(newdata).find(
                (item: any) => item.accessor == 'invdt'
              )?.timeDiff;
              dateRange = JSON.parse(newdata).find(
                (item: any) => item.accessor == 'invdt'
              )?.dateRange;
            }
            if (filterApiState.invdt && timeFlag == 'day' && dateRange) {
              filterApiState.invdt[1] = moment()
                .subtract(Math.abs(dateRange.to), 'days')
                .endOf('day')
                .toISOString()
              filterApiState.invdt[0] = moment()
                .subtract(Math.abs(dateRange.from), 'days')
                .startOf('day')
                .toISOString();
            }
          }
          for (let i of Object.keys(filterApiState)) {
            if (filterApiState[i]) {
              finalFilterApiState[i] = filterApiState[i];
            }
          }
          if (
            (profileDetails.partnerType === 'customer' &&
              profileDetails.partnerId &&
              grids?.[0]?.whereClause) ||
            profileDetails.partnerType === 'liner'
          ) {
            dispatch(
              getDashboardData({
                gridName: dashboarName,
                payload: {
                  fields: /*  SelectedViewFields?.fields || */[],
                  filters: finalFilterApiState ?? {},

                  size: 10,
                  sorts: sortState && sortState?.key != null && sortState?.value != null ? [`${sortState?.key} ${sortState?.value}`] : sort ? [sort] : [defaultSort],
                  page: currentPageUser,
                },
                dataCountry: dataCountry,
                partnerId: profileDetails.partnerId,
                where: grids?.[0]?.whereClause
                  ? AESEncrypt(grids?.[0]?.whereClause)
                  : null,
                parameter:
                  selectedTopSearchFilter?.where !== ''
                    ? {
                      searchParameter: searchInputValue,
                      searchWhere: selectedTopSearchFilter?.where,
                    }
                    : {},
              })
            );
          }
        }
      } else if (
        (profileDetails.partnerType === 'customer' &&
          profileDetails.partnerId &&
          grids?.[0]?.whereClause) ||
        profileDetails?.partnerType === 'liner'
      ) {
        dispatch(
          getDashboardData({
            gridName: dashboarName,
            payload: {
              fields: /* SelectedViewFields?.fields || */[],
              filters:
                selectedTopSearchFilter?.where === '' ? userTopSearchState : {},
              size: 10,
              sorts: sortState && sortState?.key != null && sortState?.value != null ? [`${sortState?.key} ${sortState?.value}`] : sort ? [sort] : [defaultSort],
              page: currentPageUser,
            },
            dataCountry: dataCountry,
            partnerId: profileDetails.partnerId,
            where: grids?.[0]?.whereClause
              ? AESEncrypt(grids?.[0]?.whereClause)
              : null,
            parameter:
              selectedTopSearchFilter?.where !== ''
                ? {
                  searchParameter: searchInputValue,
                  searchWhere: selectedTopSearchFilter?.where,
                }
                : {},
          })
        );
      }
    }
  };

  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
  //slider
  useEffect(() => {
    if (matchPath(`${APP_PATH_PREFIX}/customerCode`, location.pathname)) {

      if (
        customerCodeList?.data?.userData?.list?.length !== 0 &&
        customerCodeList?.data?.userData?.list?.find(
          (v: any) => v?.mstUsrId === null
        ) !== undefined
      ) {
        dispatch(getUserProfile())
          .unwrap()
          .then((response: any) => {
            // dispatch(
            //   getAllUserDetailsByUser({
            //     partnerId: response?.data?.partnerId,
            //     usrId: response?.data?.userId,
            //   })
            // );
          });
      }
    }
  }, [location.pathname]);


  useEffect(() => {
    dispatch(getUserProfile())
      .unwrap()
      .then((response: any) => {
        if (customerCodeList.data.userData.list.map((v: any) => v).length === 0) {
          //   dispatch(
          //     getAllUserDetailsByUser({
          //       partnerId: response?.data?.partnerId,
          //       usrId: response?.data?.userId,
          //     })
          //   );
        }
      });
  }, []);

  const sideWidth = useMemo(
    () =>
      Object.entries({
        [`/customerCode`]: 0,
        [`/customerCode/request`]: 9,
        [`/customerCode/companyDetails/:custId`]: 9,

      }).find(([path, _]) => matchPath(path, location.pathname))?.[1] ?? 9,
    [location.pathname]
  );


  return (
    <DashboardContainer
      sideWidth={sideWidth}
      inner={false}
      innerOffset={0}
      middleScroll={false}
    // middleChildren={
    //   location.pathname.includes('/customerCode/request') ? (
    //     <CustomerCodeRequest />
    //   ) : null
    // }
    >
      <FilterView
        loadList={loadCustomerCodeDashboard}
        child={FilterViewChild}
        showColumnSettings={location.pathname === `${APP_PATH_PREFIX}/customerCode`}
        toggleColumnSettings={toggleColumnSettingsDashboard}
        configViews={
          grids?.find?.((g) => g?.gridName === dashboarName)
            ?.configGroup || []
        }
        showExport={location.pathname === `${APP_PATH_PREFIX}/customerCode`}
        showRightDiv={!!matchPath(location.pathname, '/customerCode') && !location.pathname.includes('/request') && !location.pathname.includes('/companyDetails')}
        uniqueFilterKey={uniqueFilterKey}
        data={data}
        columns={columns}
        dataLoading={false}
        columnSettingsPersistKey='@odex/customerCodeRequest/v1'
        dashboardName={dashboarName}
        gridDef={grids}
      />
      {columns?.length > 0 && (
        <DataTable
          data={data?.result || null}
          columns={columns}
          dataCountry={dataCountry || ''}
          gridName={dashboarName}
          sortable
          searchable={false}
          showColumnFilter={false}
          selection={profileDetails?.partnerType === 'liner' && rbac.rbacDetails.customerCodeApproveReject == 'Y'}
          isChecked={(row) => !!selectedRequests?.find((x) => x?.customer_mapping_request_id == row?.customer_mapping_request_id) ? 'Y' : 'N'}
          isAllChecked={(rows) => {

            if (selectedRequests.length == 0) return 'N'

            const selectedCustomerId =
              selectedRequests.length > 0
                ? selectedRequests[0].customer_id
                : null;


            const selectableRows = data.result.filter((element: any) => {
              if (element?.status_text != 'Submitted') {
                return false
              }
              if (selectedCustomerId !== null) {
                return element.customer_id === selectedCustomerId;
              }
              return true;
            })

            if (selectableRows.length === 0) return 'N';

            // const isAllSelected = selectableRows.every((row)=>{
            //   selectedRequests.includes(row.customer_mapping_request_id)
            // })

            // const someSelected = !isAllSelected && selectableRows.some((row)=>{
            //   selectedRequests.includes(row.customer_mapping_request_id)
            // })

            const isAllSelected = selectableRows.every((row) => {
              return selectedRequests.some(
                (selected) =>
                  selected.customer_mapping_request_id ===
                  row.customer_mapping_request_id
              );
            });

            const someSelected =
              !isAllSelected &&
              selectableRows.some((row) => {
                return selectedRequests.some(
                  (selected) =>
                    selected.customer_mapping_request_id ===
                    row.customer_mapping_request_id
                );
              });

            if (isAllSelected) return 'Y';
            if (someSelected) return 'S';
            return 'N';

          }
          }
          onSelectRow={(data) => {
            console.log(data, "data.action1234")
            switch (data.action) {
              case 'add':
                const selectedCustomerId =
                  selectedRequests.length > 0
                    ? selectedRequests[0].customer_id
                    : null;

                if (data?.row?.status_text == 'Rejected' || data?.row?.status_text == 'Completed') {
                  toast.error(
                    `Request is already ${data?.row?.status_text}`
                  );
                  return;
                }
                if (
                  selectedCustomerId !== null &&
                  data.row.customer_id !== selectedCustomerId
                ) {
                  toast.error('You can select requests only for the same customer');
                  return;
                }
                dispatch(updateSelectedRequests([...selectedRequests, data.row]));
                break;
              case 'remove':
                dispatch(updateSelectedRequests(selectedRequests.filter(x => x.customer_mapping_request_id != data.row.customer_mapping_request_id)))
                break
              case 'addAll':
                const validRequests: any[] = [];

                for (const element of data?.rows || []) {
                  if (element.status_text == 'Rejected' || element.status_text == 'Completed') {
                    continue;
                  }

                  const isFirstRequest =
                    validRequests.length === 0 && selectedRequests.length === 0;

                  if (isFirstRequest) {
                    validRequests.push(element);
                    continue;
                  }

                  const firstRequest =
                    selectedRequests.length === 0
                      ? validRequests[0]
                      : selectedRequests[0];

                  if (element.status_text == 'Submitted' && element.customer_id === firstRequest.customer_id) {

                    validRequests.push(element);
                  }
                }
                if (validRequests.length > 0) {
                  dispatch(updateSelectedRequests([...selectedRequests, ...validRequests]));
                }

                break

              case 'removeAll':
                // console.log("remove all")
                dispatch(updateSelectedRequests(selectedRequests?.filter(x => !data.rows?.find((y: any) => x.customer_mapping_request_id == y.customer_mapping_request_id))))
                break

            }
          }
          }
          perPage={10}
          pagination
          numberPagination
          maxPage={parseInt(data?.maxPage || '10')}
          hasNext={data?.hasNext}
          currentPage={currentPageUser}
          gridId={grids?.[0]?.gridId || 0}
          onChangePageNumber={(pageNumber) =>
            setCurrentPage(pageNumber)
          }
          showExport={false}
          showColumnSettings={showColumnSettings}
          onHide={onHideColumnSettings}
          uniqueFilterKey={uniqueFilterKey}
          staticHiddenCols={configs?.staticHiddenCols || []}
          tableMinHeight={400}
          dataLoading={loading}
          customSort={true}
          defaultHiddenCols={configs?.defaultHiddenCols || []}
          configGroup={grids?.find?.(g => g?.gridName === dashboarName)?.configGroup || []}
        />
      )}

    </DashboardContainer>
  );
};

export default CustomerCodeDashboard;
